import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import { PageErrorBoundary } from './components/ui';
import Dashboard from './pages/Dashboard';
import BrawlersList from './pages/BrawlersList';
import BrawlerDetail from './pages/BrawlerDetail';
import MapsList from './pages/MapsList';
import MapDetail from './pages/MapDetail';
import PlayersList from './pages/PlayersList';
import PlayerProfile from './pages/PlayerProfile';
import MetaReport from './pages/MetaReport';
import News from './pages/News';
import NewsPost from './pages/NewsPost';
import ClashAdvisor from './pages/ClashAdvisor';
import ClashHeroes from './pages/ClashHeroes';
import ClashDecks from './pages/ClashDecks';
import ClashMeta from './pages/ClashMeta';
import Privacy from './pages/Privacy';
import ClashTrending from './pages/ClashTrending';
import './App.css';

function AppRoutes() {
  const { pathname } = useLocation();
  return (
    <PageErrorBoundary resetKey={pathname}>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/brawlers" element={<BrawlersList />} />
        <Route path="/brawlers/:id" element={<BrawlerDetail />} />
        <Route path="/maps" element={<MapsList />} />
        <Route path="/maps/:name" element={<MapDetail />} />
        <Route path="/news" element={<News />} />
        <Route path="/news/:slug" element={<NewsPost />} />
        <Route path="/meta-report" element={<MetaReport />} />
        <Route path="/meta-report/:week" element={<MetaReport />} />
        <Route path="/players" element={<PlayersList />} />
        <Route path="/players/:tag" element={<PlayerProfile />} />
        <Route path="/clash" element={<ClashAdvisor />} />
        <Route path="/clash/heroes" element={<ClashHeroes />} />
        <Route path="/clash/evolutions" element={<ClashHeroes form="evo" />} />
        <Route path="/clash/meta" element={<ClashMeta />} />
        <Route path="/clash/trending" element={<ClashTrending />} />
        <Route path="/clash/decks" element={<ClashDecks />} />
        <Route path="/clash/decks/:tag" element={<ClashDecks />} />
        <Route path="/clash/:tag" element={<ClashAdvisor />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="*" element={<div className="page"><div className="wrap"><p className="empty-state">Page not found</p></div></div>} />
      </Routes>
    </PageErrorBoundary>
  );
}

function App() {
  return (
    <Router>
      <Layout>
        <AppRoutes />
      </Layout>
    </Router>
  );
}

export default App;
